import { memo, useEffect } from "react";
import { useQuery } from "react-query";
import { Col, Flex, Row, Skeleton, Table, TableColumnsType } from "antd";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { ActionService } from "../../services/ActionService";
import { mdlActionCreateParams } from "../../models/domain/value-objects/ActionCreateParams";
import { mdlSpoOfferDetailRequest } from "../../models/service-models/action/SpoOfferDetailRequest";
import _ from "lodash";
import { mdlSpoOfferDetail } from "../../models/domain/SpoOfferDetail";
import { nanoid } from "@reduxjs/toolkit";

export type ExpandableActionDetailTableProps = {
    id?: string;
}

export const ExpandableActionDetailTable = (props: ExpandableActionDetailTableProps) => {
    const { t } = useTranslation();

    const {
        data,
        isLoading
    } = useQuery(
        ["getActionTemplateDetail", props.id],
        () => {
            if (props.id) {
                var request: mdlSpoOfferDetailRequest = { id: props.id };
                return ActionService.SpoOfferDetail(request);
            }
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!props.id
        }
    );

    useEffect(() => {
    }, [props]);

    const markets = _.first(data?.body?.data)?.markets;
    const agencies = _.first(data?.body?.data)?.agencies;

    const expandColumns: TableColumnsType<mdlSpoOfferDetail> = [
        {
            title: <>
                <Row gutter={16}><Col><strong>{t("action.template.markets")} :</strong></Col> <Col><label className="standard-font"> {markets == "" ? t("action.template.marketsAll") : markets}</label></Col></Row>
                <Flex vertical justify="start" align="start"><strong>{t("action.template.agencies")} : </strong><label className="standard-font">{agencies}</label></Flex></>,
            children: [
                { title: t("action.template.hotel"), dataIndex: 'hotelName', key: 'hotelName' },
                { title: t("action.template.roomType"), dataIndex: 'roomTypeName', key: 'roomTypeName' },
                { title: t("action.template.boardName"), dataIndex: 'boardName', key: 'boardName' },
                {
                    title: t("action.template.accomDateStart"), key: 'accomDateStart',
                    render: (e: mdlSpoOfferDetail) => {
                        return dayjs(e.accomDateStart).format("DD-MM-YYYY")
                    }
                },
                {
                    title: t("action.template.accomDateEnd"), key: 'accomDateEnd',
                    render: (e: mdlSpoOfferDetail) => {
                        return dayjs(e.accomDateEnd).format("DD-MM-YYYY")
                    }
                },
                {
                    title: t("action.template.priceType"), key: 'priceType',
                    render: (e: mdlSpoOfferDetail) => {
                        switch (e.priceType) {
                            case 0:
                                return t("action.template.perPerson");
                            default:
                                return t("action.template.perRoom");
                        }
                    }
                },

                {
                    title: t("action.template.price"), key: 'price',
                    render: (e: mdlSpoOfferDetail) => {
                        return e.discountRate ? `%${e.discountRate}` : e.price;
                    }
                },
                {
                    title: t("action.template.currency"), key: 'currency',
                    render: (e: mdlSpoOfferDetail) => {
                        switch (e.currency) {
                            case 0: return "TL";
                            case 1: return "EURO";
                            case 2: return "USD";
                            case 3: return "GBP";
                            default: return "";
                        }
                    }
                }
            ]
        }
    ];

    return (
        <>
            {
                isLoading
                &&
                <Skeleton active />
            }
            {
                data
                &&
                <Table<mdlSpoOfferDetail>
                    columns={expandColumns}
                    dataSource={data!.body!.data!.map((d: mdlSpoOfferDetail, index: number) => ({ ...d, key: index }))}
                    pagination={false}
                />
            }
        </>
    )
}